// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ButtonCounter_wrapper__NpPw2","inputNumber":"ButtonCounter_inputNumber__2M_5R"};